/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowDocSectionDtoSchema } from "./dealflowDocSectionDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowDocChecklistDtoSchema = z.object({
  status: z.optional(z.string()),
  get sections() {
    return z.array(dealflowDocSectionDtoSchema).optional();
  },
});
